<div class="common-wrapper">
    <div class="main-hd-txt">
        <h4>
            <pageheader [entity]="headerDesignationLevel"></pageheader>
        </h4>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="designationlevels" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="designationlevelColumns" [selectionField]="'Designation_Level_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addDesignationLevel($event)" (editEntity)="editDesignationLevel($event)"
            (refreshEntities)="refreshDesignationLevel($event)" (deleteEntity)="deleteDesignationLevel($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearDesignationLevel()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Designation Level Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                [fieldName]="'DesignationLevelName'" [(ngModel)]="entity.DesignationLevelName" ngDefaultControl></textbox>
         </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [mandatory]="false" [multiline]="true" [formData]="entity"
                            [maxlength]="500" [fieldName]="'Description'" [(ngModel)]="entity.Description"
                            ngDefaultControl>
                        </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'OrderNo'" [mandatory]="true" [maxlength]="2" [formData]="entity"
                            [fieldName]="'OrderNo'" (keypress)="numberOnly($event)" [(ngModel)]="entity.OrderNo"
                            ngDefaultControl></textbox>
                </div>
            </div>
         
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div>
        </div>
        
    </div>
</div>

<kendo-excelexport [data]="designationlevels.data" [collapsible]="true" fileName="DesignationLevel.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DesignationLevelName" title="Name" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Description" title="Description" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="OrderNo" title="Order" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>